import dayjs, { Dayjs } from "dayjs";

import { TheftRecoveryFeature } from "./TheftRecovery/TheftRecoveryFeature";
import { RoadsideAssistanceFeature } from "./RoadsideAssistance/RoadsideAssistanceFeature";
import { HealthMonitorFeature } from "./HealthMonitor/HealthMonitorFeature";
import { GenericFeature } from "./GenericFeature/GenericFeature";
import { CarbucksRewardsFeature } from "./CarbucksRewards/CarbucksRewardsFeature";
import { CarbucksProtectFeature } from "./CarbucksProtect/CarbucksProtectFeature";
import { CarbucksGuaranteeFeature } from "./CarbucksGuarantee/CarbucksGuaranteeFeature";
import { WorkOrderType } from "./WorkOrders/WorkOrderType";
import { FeatureType } from "./WorkOrders/FeatureType";
import type { ICarePlan, ICarePlanDto } from "./ICarePlan";
import type { IGenericFeature } from "./GenericFeature/IGenericFeature";
import type { IHealthMonitorFeature } from "./HealthMonitor/IHealthMonitorFeature";
import type { ITheftRecoveryFeature } from "./TheftRecovery/ITheftRecoveryFeature";
import type { IRoadsideAssistanceFeature } from "./RoadsideAssistance/IRoadsideAssistanceFeature";
import type { ICarbucksRewardsFeature } from "./CarbucksRewards/ICarbucksRewardsFeature";
import type { ICarbucksProtectFeature } from "./CarbucksProtect/ICarbucksProtectFeature";
import type { ICarbucksGuaranteeFeature } from "./CarbucksGuarantee/ICarbucksGuaranteeFeature";
import type { IWorkOrderHistoryItemDto } from "./WorkOrders/IWorkOrderHistoryItem";

export class CarePlan implements ICarePlan
{

    title: string;
    isEnabled: boolean;
    utcDateWelcomeFlowCompleted?: Dayjs;
    healthMonitor: IHealthMonitorFeature;
    theftRecovery: ITheftRecoveryFeature;
    roadsideAssistance: IRoadsideAssistanceFeature;
    carbucksRewards: ICarbucksRewardsFeature;
    carbucksProtect: ICarbucksProtectFeature;
    carbucksGuarantee: ICarbucksGuaranteeFeature;
    mechanicalProtection: IGenericFeature;
    fuel: IGenericFeature;
    marketplace: IGenericFeature;

    constructor( model: ICarePlanDto )
    {

        this.title = model.title;
        this.isEnabled = model.isEnabled;
        this.utcDateWelcomeFlowCompleted = model.utcDateWelcomeFlowCompleted != undefined ? dayjs( model.utcDateWelcomeFlowCompleted ) : undefined;

        this.carbucksRewards = new CarbucksRewardsFeature( model.carbucksRewards );
        this.carbucksProtect = new CarbucksProtectFeature( model.carbucksProtect );
        this.carbucksGuarantee = new CarbucksGuaranteeFeature( model.carbucksGuarantee );
        this.healthMonitor = new HealthMonitorFeature( model.healthMonitor );
        this.theftRecovery = new TheftRecoveryFeature( model.theftRecovery );
        this.roadsideAssistance = new RoadsideAssistanceFeature( model.roadsideAssistance );
        this.mechanicalProtection = new GenericFeature( model.mechanicalProtection );
        this.fuel = new GenericFeature( model.fuel );
        this.marketplace = new GenericFeature( model.marketplace );
    }

    /**
     * Gets a CarePlan item from the care plan if it is enabled
     * @param type 
     * @returns 
     */
    getItem( type: WorkOrderType, product?: FeatureType )
    {

        const carbucksProtectItem = this.carbucksProtect.isEnabled 
            ? this.carbucksProtect.workOrderConfigurations.find( i => i.type == type && ( product == null || i.product == product ) )
            : undefined;
        if( carbucksProtectItem != undefined ) return carbucksProtectItem;

        const carbucksRewardsItem = this.carbucksRewards.isEnabled 
            ? this.carbucksRewards.workOrderConfigurations.find( i => i.type == type && ( product == null || i.product == product ) )
            : undefined;
        return carbucksRewardsItem;

    }

    /**
     * Gets a CarePlan items history from the care plan if it is enabled
     * @param type 
     * @returns 
     */
    getItemHistory( type: WorkOrderType, product?: FeatureType ): IWorkOrderHistoryItemDto[]
    {
        const item = this.getItem( type, product );
        return item?.history ?? [];
    }

    get showReminders()
    {
        return this.carbucksRewards.isEnabled == false || 
               this.carbucksRewards.isRemindersEnabled
    }

}